import { useContext, createContext, useState, useEffect } from 'react'

import { toggleGroupCommunityModalEventsPayloadListener } from '@space-events/toggleCommunityGroupModal'
import type { CommunityGroupCreateResponse } from '@space-shell/common/services/communities'
import { modalEventDispatch, modalEventListener } from '@space-shell/common/services/modal'

import type { GroupCommunityModalContextProps, GroupCommunityModalProviderProps } from './types'

import GroupCommunityModal from '../..'

export type GroupCommunityModalEventsPayload = {
  action: 'open' | 'close'
  group?: CommunityGroupCreateResponse
  isEditing?: boolean
}
const GroupCommunityModalContext = createContext<GroupCommunityModalContextProps>(
  {} as GroupCommunityModalContextProps
)

export const GroupCommunityModalProvider = ({ children }: GroupCommunityModalProviderProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [group, setGroup] = useState<CommunityGroupCreateResponse>()
  const [isEditing, setIsEditing] = useState(false)

  const reset = () => {
    setIsOpen(false)
    setGroup(undefined)
    setIsEditing(false)
  }

  useEffect(() => {
    /* istanbul ignore next */
    toggleGroupCommunityModalEventsPayloadListener((event) => {
      const payload = (event as CustomEvent<GroupCommunityModalEventsPayload>).detail
      switch (payload.action) {
        case 'close':
          reset()
          break
        case 'open':
          setIsOpen(true)
          payload?.group && Object.keys(payload.group).length && setGroup(payload.group)
          break
      }
    })
  }, [])

  useEffect(() => {
    /* istanbul ignore next */
    modalEventListener((event) => {
      const payload = (event as CustomEvent<GroupCommunityModalEventsPayload>).detail
      switch (payload.action) {
        case 'close':
          reset()
          break
        case 'open':
          setIsOpen(true)
          payload?.group && Object.keys(payload.group).length && setGroup(payload.group)
          break
      }
    })
  }, [])

  const openGroupModal = (group?: CommunityGroupCreateResponse) => {
    modalEventDispatch({ action: 'open', group })
  }

  const closeGroupModal = () => {
    modalEventDispatch({ action: 'close' })
    reset()
  }

  return (
    <GroupCommunityModalContext.Provider
      value={{
        openGroupModal,
        closeGroupModal,
        setIsEditing,
        isOpen
      }}>
      <GroupCommunityModal
        isEditing={isEditing}
        isOpen={isOpen}
        group={group}
        closeModal={closeGroupModal}
      />
      {children}
    </GroupCommunityModalContext.Provider>
  )
}

export const useGroupCommunityModal = () => {
  const context = useContext(GroupCommunityModalContext)

  return context
}
